import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {AbstractControlReadonlyComponent} from './abstract-control-readonly';
import {ViewTabComponent} from '../viewtab.component';
import xss from 'xss';
import {ErrorService} from '../../../error/error.service';

@Component({
  selector: 'ctrl-markdownarea',
  template: ` <div class="markdownArea" [innerHtml]="htmlValue"></div>`,
  encapsulation: ViewEncapsulation.None,
  styles: ['.markdownArea > *:first-child { margin-top: 0; }'],
  standalone: false,
})
export class CtrlMarkdownAreaComponent extends AbstractControlReadonlyComponent {
  showDownConverter: any = null;

  constructor(
    parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    errorService: ErrorService,
  ) {
    super(parent, null, changeDetector, errorService);
    const showdown = require('showdown');
    const showdownHtmlEscape = require('showdown-htmlescape');

    // Extension
    showdown.extension('targetlink', function () {
      return [
        {
          type: 'lang',
          regex:
            /\[((?:\[[^\]]*]|[^\[\]])*)]\([ \t]*<?(.*?(?:\(.*?\).*?)?)>?[ \t]*((['"])(.*?)\4[ \t]*)?\)\{\:target=(["'])(.*)\6}/g,
          replace: function (wholematch, linkText, url, a, b, title, c, target) {
            var result = '<a href="' + url + '"';

            if (typeof title != 'undefined' && title !== '' && title !== null) {
              title = title.replace(/"/g, '&quot;');
              title = showdown.helper.escapeCharacters(title, '*_', false);
              result += ' title="' + title + '"';
            }

            if (typeof target != 'undefined' && target !== '' && target !== null) {
              result += ' target="' + target + '"';
            }

            result += '>' + linkText + '</a>';
            return result;
          },
        },
      ];
    });

    this.showDownConverter = new showdown.Converter({
      extensions: [showdownHtmlEscape, 'targetlink'],
      headerLevelStart: 3,
    });
  }

  htmlValue: string = null;

  protected initMain(): void {
    this.sourceObs.subscribe((markdown: string) => {
      if (markdown == null) {
        this.htmlValue = null;
        return;
      }
      // TODO: how to handle line breaks in markdown? Json converter removes xml line breaks
      markdown = markdown.replace(/\._\.( )?/g, '\n');
      this.htmlValue = xss(this.showDownConverter.makeHtml(markdown));
    });
  }
}
